// Dictionary of common Arabic names and department words to accurate English
const ARABIC_TO_ENGLISH_DICT = {
  // Compound Prefix Names
  "عبدالله": "Abdullah", "عبد الله": "Abdullah",
  "عبدالرحمن": "Abdelrahman", "عبد الرحمن": "Abdelrahman",
  "عبدالعزيز": "Abdelaziz", "عبد العزيز": "Abdelaziz",
  "عبدالمجيد": "Abdelmajeed", "عبد المجيد": "Abdelmajeed",
  "عبدالحميد": "Abdelhameed", "عبد الحميد": "Abdelhameed",
  "عبدالقادر": "Abdelqader", "عبد القادر": "Abdelqader",
  "عبدالفتاح": "Abdelfattah", "عبد الفتاح": "Abdelfattah",
  "عبدالوهاب": "Abdelwahab", "عبد الوهاب": "Abdelwahab",
  "عبدالنبي": "Abdelnaby", "عبدالنبى": "Abdelnaby", "عبد النبي": "Abdelnaby",
  "عبدالرازق": "Abdelrazek", "عبد الرازق": "Abdelrazek",
  "عبدالسلام": "Abdelsalam", "عبد السلام": "Abdelsalam",
  "عبدالحكيم": "Abdelhakeem", "عبد الحكيم": "Abdelhakeem",
  "عبدالغني": "Abdelghany", "عبدالغنى": "Abdelghany", "عبد الغني": "Abdelghany", "عبد الغنى": "Abdelghany",
  "عبدالعال": "Abdelaal", "عبد العال": "Abdelaal",
  "عبدالستار": "Abdelsattar", "عبد الستار": "Abdelsattar",
  "عبدالجواد": "Abdelgawad", "عبد الجواد": "Abdelgawad",
  "عبدالمنعم": "Abdelmonem", "عبد المنعم": "Abdelmonem",
  "عبدالمقصود": "Abdelmaqsoud", "عبد المقصود": "Abdelmaqsoud",
  "عبداللطيف": "Abdellatif", "عبد اللطيف": "Abdellatif",
  "عبدالخالق": "Abdelkhaleq", "عبد الخالق": "Abdelkhaleq",
  "عبدالهادي": "Abdelhady", "عبدالهادى": "Abdelhady", "عبد الهادي": "Abdelhady",

  // Common Names
  "محمد": "Mohamed",
  "محمود": "Mahmoud",
  "احمد": "Ahmed", "أحمد": "Ahmed", "إحمد": "Ahmed",
  "ابراهيم": "Ibrahim", "إبراهيم": "Ibrahim",
  "مصطفى": "Moustafa", "مصطفي": "Moustafa",
  "علي": "Ali", "على": "Ali",
  "حسن": "Hassan",
  "حسين": "Hussein",
  "سعيد": "Saeed",
  "سعد": "Saad",
  "سيد": "Sayed",
  "طاهر": "Tahir",
  "عمر": "Omar",
  "عمرو": "Amr",
  "عثمان": "Othman",
  "خالد": "Khaled",
  "وليد": "Waleed",
  "ياسر": "Yasser",
  "يوسف": "Youssef",
  "يسري": "Yousry", "يسرى": "Yousry",
  "ايمن": "Ayman", "أيمن": "Ayman",
  "اسلام": "Islam", "إاسلام": "Islam", "إسلام": "Islam",
  "اشرف": "Ashraf", "أشرف": "Ashraf",
  "تامر": "Tamer",
  "سامح": "Sameh",
  "شريف": "Sherif",
  "حاتم": "Hatem",
  "حازم": "Hazem",
  "طارق": "Tarek",
  "زياد": "Ziad",
  "ماجد": "Maged",
  "مجدي": "Magdy", "مجدى": "Magdy",
  "رامي": "Ramy", "رامى": "Ramy",
  "هاني": "Hany", "هانى": "Hany",
  "وائل": "Wael",
  "بكري": "Bakry", "بكرى": "Bakry",
  "عابدين": "Abdeen",
  "الزكيري": "Al-Zokari", "زكيري": "Zokari", "زكيرى": "Zokari", "الزكيرى": "Al-Zokari",
  "دكروري": "Dakroury", "دكرورى": "Dakroury", "الدكروري": "Al-Dakroury", "الدكرورى": "Al-Dakroury",
  "مصرى": "Masry", "مصري": "Masry", "المصري": "Al-Masry", "المصرى": "Al-Masry",
  "عبده": "Abdo",
  "عيد": "Eid",
  "رضا": "Reda",
  "كمال": "Kamal",
  "جمال": "Gamal",
  "عادل": "Adel",
  "صلاح": "Salah",
  "عصام": "Essam",
  "هشام": "Hesham",
  "ايهاب": "Ehab", "إيهاب": "Ehab",
  "عاطف": "Atef",
  "سامي": "Samy", "سامى": "Samy",
  "ممدوح": "Mamdouh",
  "مدحت": "Medhat",
  "نبيل": "Nabil",
  "ناجي": "Nagy", "ناجى": "Nagy",
  "فتحي": "Fathy", "فتحى": "Fathy",
  "فهمي": "Fahmy", "فهمى": "Fahmy",
  "صفوت": "Safwat",
  "عزت": "Ezzat",
  "رافت": "Raafat", "رأفت": "Raafat",
  "شادي": "Shady", "شادى": "Shady",
  "فادي": "Fady", "فادى": "Fady",
  "جورج": "George",
  "مينا": "Mina",
  "بيشوي": "Bishoy", "بيشوى": "Bishoy",
  "كيرلس": "Kerollos",
  "امير": "Amir", "أمير": "Amir",

  // Departments
  "امن": "Security", "أمن": "Security", "الأمن": "Security", "الامن": "Security",
  "مالية": "Finance", "المالية": "Finance",
  "مشتريات": "Procurement", "المشتريات": "Procurement",
  "مبيعات": "Sales", "المبيعات": "Sales",
  "تسويق": "Marketing", "التسويق": "Marketing",
  "تشغيل": "Operations", "التشغيل": "Operations",
  "صيانة": "Maintenance", "الصيانة": "Maintenance",
  "موارد بشرية": "Human Resources", "الموارد البشرية": "Human Resources",
  "تكنولوجيا المعلومات": "Information Technology",
  "مخازن": "Warehouses", "المخازن": "Warehouses",
  "انتاج": "Production", "الانتاج": "Production", "إنتاج": "Production", "الإنتاج": "Production"
};

const CHAR_MAP = {
  'أ': 'A', 'إ': 'I', 'آ': 'A', 'ا': 'A', 'ب': 'B', 'ت': 'T', 'ث': 'Th',
  'ج': 'G', 'ح': 'H', 'خ': 'Kh', 'د': 'D', 'ذ': 'Dh', 'ر': 'R', 'ز': 'Z',
  'س': 'S', 'ش': 'Sh', 'ص': 'S', 'ض': 'D', 'ط': 'T', 'ظ': 'Z', 'ع': 'A',
  'غ': 'Gh', 'ف': 'F', 'ق': 'Q', 'ك': 'K', 'ل': 'L', 'م': 'M', 'ن': 'N',
  'ه': 'H', 'و': 'W', 'ي': 'Y', 'ى': 'Y', 'ئ': 'Y', 'ؤ': 'O', 'ة': 'h'
};

export const transliterateArabicToEnglish = (text) => {
  if (!text || typeof text !== "string") return "";
  const cleaned = text.trim();
  if (!/[\u0600-\u06FF]/.test(cleaned)) return cleaned;

  // Check full match in dictionary first
  if (ARABIC_TO_ENGLISH_DICT[cleaned]) {
    return ARABIC_TO_ENGLISH_DICT[cleaned];
  }

  // Handle multi-word strings by replacing known compounds and words
  let working = cleaned;
  
  // Replace compound phrases like "عبد الله" or "عبدالرحمن"
  for (const [ar, en] of Object.entries(ARABIC_TO_ENGLISH_DICT)) {
    if (ar.includes(" ")) {
      working = working.replace(new RegExp(ar, "g"), en);
    }
  }

  const words = working.split(/\s+/);
  const resultWords = words.map((w) => {
    if (!/[\u0600-\u06FF]/.test(w)) return w;
    if (ARABIC_TO_ENGLISH_DICT[w]) return ARABIC_TO_ENGLISH_DICT[w];

    // Transliterate word letter-by-letter
    let stripped = w.replace(/[\u064B-\u0652]/g, ""); // Remove Arabic diacritics
    let prefix = "";
    if (stripped.startsWith("ال") && stripped.length > 3) {
      prefix = "Al-";
      stripped = stripped.slice(2);
      if (ARABIC_TO_ENGLISH_DICT[stripped]) {
        return prefix + ARABIC_TO_ENGLISH_DICT[stripped];
      }
    }

    let trans = "";
    for (let i = 0; i < stripped.length; i++) {
      const ch = stripped[i];
      trans += CHAR_MAP[ch] || ch;
    }

    if (!trans) return w;
    const formatted = prefix + trans.charAt(0).toUpperCase() + trans.slice(1).toLowerCase();
    return formatted;
  });

  return resultWords.join(" ");
};

export const deptName = (dept, language) => {
  if (!dept) return "";
  let name = language === "ar" ? dept?.nameAr || dept?.name : dept?.name || dept?.nameAr;
  if (!name) return "";

  if (language !== "ar" && /[\u0600-\u06FF]/.test(name)) {
    return transliterateArabicToEnglish(name);
  }
  return name;
};

// The other-language name, shown as a secondary line — only when it differs.
export const deptAltName = (dept, language) => {
  const alt = language === "ar" ? dept?.name : dept?.nameAr;
  return alt && alt !== deptName(dept, language) ? alt : "";
};

export const personName = (emp, language) => {
  if (!emp) return "";
  let rawName = "";
  if (language === "ar") {
    rawName = emp?.arabicName || emp?.sr || emp?.name || "";
  } else {
    // English mode: check if any name field contains English text
    const enName = [emp?.sr, emp?.name, emp?.englishName, emp?.fullName].find(
      (val) => typeof val === "string" && val.trim() && !/[\u0600-\u06FF]/.test(val)
    );
    if (enName) {
      rawName = enName.trim();
    } else {
      // Fallback: take available Arabic name and transliterate to English
      const arName = [emp?.sr, emp?.arabicName, emp?.name].find(
        (val) => typeof val === "string" && val.trim()
      ) || "";
      rawName = transliterateArabicToEnglish(arName);
    }
  }
  return rawName;
};

// Returns true when the displayed name comes from the *other* language
export const personNameIsFallback = (emp, language) => {
  if (!emp) return false;
  if (language === "ar") return !emp.arabicName && !!emp.sr;
  return !emp.sr && !!emp.arabicName;
};

export const employeeCode = (emp) => emp?.clientCode || emp?.infinityCode || "";

export const managerLabel = (manager, language) =>
  personName(manager?.employee, language) || employeeCode(manager?.employee) || manager?.infinityCode || "";
